
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'MSvgCopy',
  props: {
    color: {
      type: String as PropType<string>,
      default: '#6667AB'
    },
    width: {
      type: String,
      default: '48'
    },
    height: {
      type: String,
      default: '48'
    }
  }
})
